import { getAccountConfig } from 'components/account/AccountProvider';
/**
 * Returns the picker formatter of sale items. The title follows the primary
 * sale item info of the account, the SKU is left out when it is hidden in
 * the account and the category is the sale item group.
 * @function useSaleItemPickerFormat
 * @since 1.0.0
 */
export function useSaleItemPickerFormat() {
    const primarySaleItemInfo = getAccountConfig('PRIMARY_SALE_ITEM_INFO');
    //const hideSku = getAccountConfig('HIDE_SKU') === 'TRUE';
    const hideSku = false;
    return (saleItem) => {
        var _a, _b, _c;
        const skuFirst = primarySaleItemInfo == 'SKU' && !!saleItem.sku;
        return {
            id: saleItem.id,
            title: (_a = (skuFirst ? saleItem.sku : saleItem.title)) !== null && _a !== void 0 ? _a : '',
            infos: (_b = (skuFirst ? saleItem.title : hideSku ? '' : saleItem.sku)) !== null && _b !== void 0 ? _b : '',
            category: (_c = saleItem.group) === null || _c === void 0 ? void 0 : _c.title,
            partners: saleItem.partners
        };
    };
}
/**
 * Returns the picker formatter of sale item packages, following the same
 * rules as sale items. The category lists the package groups.
 * @function useSaleItemPackagePickerFormat
 * @since 1.0.0
 */
export function useSaleItemPackagePickerFormat() {
    const primarySaleItemInfo = getAccountConfig('PRIMARY_SALE_ITEM_INFO');
    const hideSku = getAccountConfig('HIDE_SKU') === 'TRUE';
    return (saleItemPackage) => {
        var _a, _b, _c;
        const skuFirst = primarySaleItemInfo == 'SKU' && !!saleItemPackage.sku;
        return {
            id: saleItemPackage.id,
            title: (_a = (skuFirst ? saleItemPackage.sku : saleItemPackage.title)) !== null && _a !== void 0 ? _a : '',
            infos: (_b = (skuFirst
                ? saleItemPackage.title
                : hideSku
                    ? ''
                    : saleItemPackage.sku)) !== null && _b !== void 0 ? _b : '',
            category: (_c = saleItemPackage.groups) === null || _c === void 0 ? void 0 : _c.map((group) => group === null || group === void 0 ? void 0 : group.title).filter(Boolean).join(', ')
        };
    };
}
